/**
 * Scaffolding marker.
 *
 * Every screen renders one of these until the design references arrive. The
 * deliberately plain look is the point: it should be obvious at a glance that
 * nothing here has been designed yet, rather than looking like a finished
 * screen somebody chose.
 *
 * Replace each page's <Placeholder /> with the real UI once there is a
 * reference image in docs/references/ to build against.
 */

import './Placeholder.css'

export default function Placeholder({ screen, purpose, children }) {
  return (
    <div className="ziv-placeholder">
      <div className="ziv-placeholder__card">
        <p className="ziv-placeholder__tag">screen</p>
        <h1 className="ziv-placeholder__name">{screen}</h1>
        {purpose && <p className="ziv-placeholder__purpose">{purpose}</p>}
        <p className="ziv-placeholder__note">Not designed yet — awaiting reference images.</p>
        {children && <div className="ziv-placeholder__body">{children}</div>}
      </div>
    </div>
  )
}
